import './button.scss';
import React, {
	CSSProperties,
	MouseEvent, ReactNode,
} from 'react';
import {
	ButtonColor,
	ButtonType,
} from '.';



interface ButtonProps {
  small?: boolean;
	color?: ButtonColor;
	type?: ButtonType;
  className?: string;
  style?: CSSProperties;
  children: JSX.Element | string | ReactNode;
  onClick?: (event?: MouseEvent<HTMLButtonElement>) => void;
	onMouseEnter?: () => void;
	onMouseLeave?: () => void;
	disabled?: boolean;
}

export const Button = ({
	color = ButtonColor.PRIMARY,
	type = ButtonType.BUTTON,
	onClick = () => {},
	onMouseEnter = () => {},
	onMouseLeave = () => {},
	className,
	children,
	style,
	// small = false,
	disabled = false,
}: ButtonProps) => (
	<button
		className={`tc-btn btn ${color} ${className || ''}`}
		style={style}
		type={type}
		onClick={(event) => onClick(event)}
		onMouseEnter={onMouseEnter}
		onMouseLeave={onMouseLeave}
		disabled={disabled}
	>
		{children}
	</button>
);